<template>
  <el-popover
    placement="top-end"
    :width="200"
    trigger="click"
    v-model:visible="visible"
    popper-class="currency-selector-popper"
  >
    <div class="currency-list">
      <div
        class="currency-item"
        v-for="(item, index) in DEFAULT_CURRENCY"
        :key="index"
        :class="{ active: item.value === modelValue }"
        @click="handleCurrencyChange(item.value)"
      >
        {{ item.label }}
        <font-icon v-if="item.value === modelValue" icon="icon-gou" />
      </div>
    </div>
    <template #reference>
      <div class="currency-selector">
        <font-icon icon="icon-huobi-1" class="icon" />
        <span class="current-currency">{{ currentCurrencyLabel }}</span>
        <font-icon
          class="arrow-icon"
          icon="icon-xiala"
          :class="{ open: visible }"
        />
      </div>
    </template>
  </el-popover>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  modelValue: {
    type: String,
    default: "zh"
  },
  useChannelLanguages: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["update:modelValue", "change"]);

const { t } = useI18n();

const DEFAULT_CURRENCY = ref([
  {
    label: t("shared.hotel.currencyList.local"),
    value: "local"
  },
  {
    label: t("shared.hotel.currencyList.USD"),
    value: "USD"
  },
  {
    label: t("shared.hotel.currencyList.CNY"),
    value: "CNY"
  },
  {
    label: t("shared.hotel.currencyList.SGD"),
    value: "SGD"
  },
  {
    label: t("shared.hotel.currencyList.HKD"),
    value: "HKD"
  },
  {
    label: t("shared.hotel.currencyList.THB"),
    value: "THB"
  },
  {
    label: t("shared.hotel.currencyList.AUD"),
    value: "AUD"
  },
  {
    label: t("shared.hotel.currencyList.EUR"),
    value: "EUR"
  },
  {
    label: t("shared.hotel.currencyList.JPY"),
    value: "JPY"
  },
  {
    label: t("shared.hotel.currencyList.TWD"),
    value: "TWD"
  },
  {
    label: t("shared.hotel.currencyList.MYR"),
    value: "MYR"
  }
]);

const visible = ref(false);

const currentCurrencyLabel = computed(() => {
  return (
    DEFAULT_CURRENCY.value.find(item => item.value === props.modelValue)
      ?.label ?? ""
  );
});

const handleCurrencyChange = value => {
  emit("update:modelValue", value);
  emit("change", value);
  visible.value = false;
};

defineOptions({
  name: "LanguageSelector"
});
</script>

<style lang="scss" scoped>
.currency-selector {
  display: flex;
  align-items: center;
  color: var(--y-currency-selector-color, #ffffff);
  cursor: pointer;
}

.icon {
  font-size: 16px;
}

.current-currency {
  font-size: var(--y-currency-selector-size, 16px);
  font-weight: 500;
  line-height: 20px;
  margin-left: 4px;
  white-space: nowrap;
}

.icon-xiala {
  width: 10px;
  font-size: 10px;
  margin-left: 8px;
  transition: transform 0.3s;
  &.open {
    transform: rotate(-180deg);
  }
}

.currency-list {
  padding: 0 8px;

  .currency-item {
    padding: 20px 0;
    font-size: 16px;
    font-weight: 500;
    color: #696969;
    line-height: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:not(:last-child) {
      border-bottom: 1px solid #eeeeee;
    }

    &:first-child {
      padding-top: 8px;
    }

    &:last-child {
      padding-bottom: 8px;
    }

    &:hover,
    &.active {
      color: var(--y-text-color);
    }

    .icon-gou {
      font-size: 12px;
    }
  }
}
</style>
<style>
.el-popper.currency-selector-popper {
  border-radius: 0;
}
</style>
